import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionProcessing.module.css";
import { checkSubscriptionApi, getProductListApi, printLogsApi, sendOTPApi, verifyOTPApi } from '../Http/http';
import Loader from '../Components/Loader';
import { FaCheck } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import Lottie from 'lottie-react';
import waitAnimation from '../animation/waitAnimation.json';
import Cookies from "js-cookie";

const SubscriptionProcessing = () => {
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState("");

    const location = useLocation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const navigate = useNavigate();

    // useEffect(() => {
    //     let apiInterval = null;

    //     // if (!loading && msisdn && attemptCount < 100) {
    //     if (!loading && msisdn) {
    //         apiInterval = setInterval(() => {
    //             handleFormSubmission();
    //         }, 2000);
    //     }

    //     return () => {
    //         if (apiInterval) {
    //             clearInterval(apiInterval);
    //         }
    //     };
    // }, [msisdn, loading]);

    // const handleFormSubmission = async () => {
    //     try {
    //         setLoading(true);
    //         const response = await checkSubscriptionApi({ msisdn });
    //         setLoading(false);

    //         if (response?.data?.result?.statusCode == 200) {
    //             Cookies.set("msisdn", msisdn, {
    //                 expires: 30,
    //             });

    //             toast.success("Subscription Successful!");
    //             navigate("/home");
    //         }

    //         if (response?.data?.result?.statusCode == 401) {
    //             console.log("low balance==");
    //         }

    //     } catch (error) {
    //         setLoading(false);
    //         console.log(error, 'error--');
    //     }
    // }

    return (
        <div className={classes.container}>
            <div className={classes.slider_content}>
                <h2 className="tlt fix" data-in-effect="fadeInLeft">Door<span> 2 </span>Games</h2>
                <p className="wow fadeInUp" data-wow-delay="2s">
                    Dive into 50+ thrilling games across action, puzzle, sports, and more. There's something for every player!
                </p>
            </div>
            <div className={classes.section_hero}>

                <div className={classes.section_stack1}>
                    {profileImages?.slice(0, 10).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}

                    {profileImages?.slice(0, 10).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}
                </div>

                <div className={classes.section_stack1}>
                    {profileImages?.slice(10, 20).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}

                    {profileImages?.slice(10, 20).map((item, index) => {
                        return (
                            <div key={index} className={classes.section_stack1_item}>
                                <img src={item} alt="" loading='lazy' className={classes.section_stack1_image} />
                            </div>
                        )
                    })}
                </div>

                <div className={classes.subscription_form}>
                    <div className={classes.description}>
                        {/* <h2 className={classes.title}>Subscription In Process</h2> */}
                        <h2 className={classes.title}>Subscription Request Submitted!</h2>
                        <ul className={classes.list}>
                            <li className={classes.text}>
                                Dear User, your subscription request is being under process.
                            </li>
                        </ul>

                        {/* <div className={classes.animation_container}>
                            <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                        </div>

                        <p className={classes.text2}>
                            You will be auto redirected when successfully subscribed!
                        </p> */}
                    </div>
                </div>

            </div>
        </div>


    )
}

export default SubscriptionProcessing;


const profileImages = [
    "/assets/game-images/crazy_match3_512x512.png",
    "/assets/game-images/danger%20runing.png",
    "/assets/game-images/delta_512x512.png",
    "/assets/game-images/double_stickman_512x512.png",
    "/assets/game-images/dragonjump_512x512.png",
    "/assets/game-images/duckshooter_512x512.png",
    "/assets/game-images/emoji%20squeeze.png",
    "/assets/game-images/faces_match_512x512.png",
    "/assets/game-images/feed.png",
    "/assets/game-images/fishnjump_512x512.png",
    "/assets/game-images/flying%20boy.png",
    "/assets/game-images/follow_line_512x512.png",
    "/assets/game-images/Aliens_Memory_512x512.png",
    "/assets/game-images/AngryCatShot_512x512.png",
    "/assets/game-images/AnimalFun_512x512.png",
    "/assets/game-images/BrickDodge_512x512.png",
    "/assets/game-images/CholiJet_512x512.png",
    "/assets/game-images/DangerousCircle_512x512.png",
    "/assets/game-images/Dark_Ninja_512x512.png",
    "/assets/game-images/Emoji_Pong_512x512.png"
];
